module.exports = __webpack_public_path__ + "static/media/planningFull.104a6b4e.jpg";